export const position = {
    labels: {
        position: "Position",
        positions: "Positions",
    },
    placeholders: {
    },
    modals: {
        titles: {
            add_position: "Add Position",
            position_remove: "Delete Position",
        },
        messages: {
            position_remove: "Are you sure you want to remove the position <strong>{name}</strong>?<br/>This operation cannot be undone.",
        },
    },
    texts: {
        delete_category: "Are you sure you want to delete this category?<br/>All services in this category will be deleted.",
    },
};
